var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "사업안내",
            "tabActive": "오시는길",
            "bg": "/images/sub/business/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("사업안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("오시는길")];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "direction-sheet",
    attrs: {
      "color": "primary"
    }
  }, [_c('tit', {
    staticClass: "tit--sm white--text"
  }, [_vm._v("2호선 건대입구역 6출구, 도보 1분 7호선 건대입구역 2번출구 도보 6분")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "map-wrap"
  }, [_c('iframe', {
    staticClass: "map",
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.60529836091!2d127.06415417642951!3d37.54080052560253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca4ebd5d75ff1%3A0x2c84180925d56ea3!2z7ISc7Jq47Yq567OE7IucIOq0keynhOq1rCDsnpDslpHrj5kgOC04!5e0!3m2!1sko!2skr!4v1730882733017!5m2!1sko!2skr",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  })]), _c('v-card', {
    staticClass: "map-card",
    attrs: {
      "flat": "",
      "tile": "",
      "color": "grey"
    }
  }, [_c('div', {
    staticClass: "map-card__inner"
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('h3', [_vm._v("주소")])]), _c('v-col', [_vm._v("서울특별시 광진구 자양동 8-8번지 외 3필지(290-12) (2, 7호선 건대입구역 6번 출구)")])], 1), _c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('h3', [_vm._v("전화")])]), _c('v-col', [_vm._v("02-6239-0330")])], 1), _c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('h3', [_vm._v("이메일")])]), _c('v-col', [_vm._v("thepodium830@naver.com")])], 1)], 1)])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }